module.exports = __webpack_public_path__ + "static/media/A9.2b81e921.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A9.png
// module id = 875
// module chunks = 0